// Central, editable public configuration for MAGABRAZIL.
// On-chain values stay null until the official contracts are deployed and verified.

export const IMG = {
  hero: "https://images.unsplash.com/photo-1784941078852-1af52accd398?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBnb2xkJTIwY3J5cHRvJTIwY29pbnxlbnwwfHx8fDE3OTI5ODIzMDZ8MA&ixlib=rb-4.1.0&q=85",
  goldSkull: "https://images.unsplash.com/photo-1678749184912-22566b52cdab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBnb2xkJTIwY3J5cHRvJTIwY29pbnxlbnwwfHx8fDE3OTI5ODIzMDZ8MA&ixlib=rb-4.1.0&q=85",
  goldLens: "https://images.unsplash.com/photo-1549936911-2e2e78f94bde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBnb2xkJTIwY3J5cHRvJTIwY29pbnxlbnwwfHx8fDE3OTI5ODIzMDZ8MA&ixlib=rb-4.1.0&q=85",
  palmClose: "https://images.unsplash.com/photo-1673433337729-46b4588f32fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxkYXJrJTIwY2luZW1hdGljJTIwbmVvbiUyMGp1bmdsZXxlbnwwfHx8fDE3OTI5ODIzMDd8MA&ixlib=rb-4.1.0&q=85",
  neonLeaves: "https://images.unsplash.com/photo-1673433341315-93eda3581919?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxkYXJrJTIwY2luZW1hdGljJTIwbmVvbiUyMGp1bmdsZXxlbnwwfHx8fDE3OTI5ODIzMDZ8MA&ixlib=rb-4.1.0&q=85",
  palmForest: "https://images.unsplash.com/photo-1722162049797-c392b5b4b296?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxkYXJrJTIwY2luZW1hdGljJTIwbmVvbiUyMGp1bmdsZXxlbnwwfHx8fDE3OTI5ODIzMDd8MA&ixlib=rb-4.1.0&q=85",
  glassStack: "https://images.unsplash.com/photo-1741649416153-b724f78821b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwYmxhY2slMjBjcmVkaXQlMjBjYXJkJTIwbW9ja3VwfGVufDB8fHx8MTc5Mjk4MjMwNnww&ixlib=rb-4.1.0&q=85",
  phone: "https://images.unsplash.com/photo-1572798793834-67d5e285760d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwYmxhY2slMjBjcmVkaXQlMjBjYXJkJTIwbW9ja3VwfGVufDB8fHx8MTc5Mjk4MjMwNnww&ixlib=rb-4.1.0&q=85",
  blackCard: "https://images.unsplash.com/photo-1613243555988-441166d4d6fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwYmxhY2slMjBjcmVkaXQlMjBjYXJkJTIwbW9ja3VwfGVufDB8fHx8MTc5Mjk4MjMwNnww&ixlib=rb-4.1.0&q=85",
  passport: "https://images.unsplash.com/photo-1537724326059-2ea20251b9c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwYmxhY2slMjBjcmVkaXQlMjBjYXJkJTIwbW9ja3VwfGVufDB8fHx8MTc5Mjk4MjMwNnww&ixlib=rb-4.1.0&q=85",
};

export const SITE = {
  name: "MAGABRAZIL",
  symbol: "$MBGA",
  network: "Solana Mainnet",
  rpcUrl: "https://api.mainnet-beta.solana.com",
  totalSupply: 900_000_000,
  launchStatus: "PRE_LAUNCH",
  mintAddress: null,
  poolAddress: null,
  treasuryAddress: null,
  lockAddress: null,
  nftCollectionAddress: null,
  nftMintEnabled: false,
  nftMinHoldingUsd: 1000,
  nftHoldingDays: 30,
  whitepaperVersion: "v0.9",
  whitepaperPdfUrl: null,
  socials: { x: null, telegram: null, discord: null, instagram: null },
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const shortAddress = (a) => (a ? `${a.slice(0, 4)}…${a.slice(-4)}` : "");

export const fmtInt = (n) => new Intl.NumberFormat("en-US").format(n);
